import { motion } from 'framer-motion';
import { FiClock, FiMapPin, FiFileText } from 'react-icons/fi';
import Button from '../common/Button';
import { SERVICE_TIMES, CONTACT_INFO } from '../../utils/constants';

export default function ServiceTimes({ serviceTimes, location, settings }) {
  // Use database data if available, otherwise fallback to constants
  const times = serviceTimes && serviceTimes.length > 0 ? serviceTimes : [
    { id: 1, service_name: SERVICE_TIMES.saturday.name, service_time: SERVICE_TIMES.saturday.time },
    { id: 2, service_name: SERVICE_TIMES.sunday.name, service_time: SERVICE_TIMES.sunday.time },
  ];

  const locationData = location || {
    name: CONTACT_INFO.name,
    address: CONTACT_INFO.address,
    city: CONTACT_INFO.city,
    state: CONTACT_INFO.state,
    zip_code: CONTACT_INFO.zip,
    bulletin_link: '/bulletin',
    bulletin_button_text: 'View Bulletin',
  };

  return (
    <section id="service-times" className="bg-highlight">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="max-w-7xl mx-auto px-4 sm:px-6 py-5"
      >
        <div className="flex flex-col lg:flex-row items-center justify-between gap-6">
          {/* Service Information */}
          <div className="flex flex-col sm:flex-row items-center gap-4 sm:gap-8 text-primary">
            {times.map((service, index) => (
              <div key={service.id || index} className="flex items-center gap-2">
                {index > 0 && <div className="hidden sm:block w-px h-5 bg-primary/20 mr-4" />}
                <FiClock className="w-5 h-5 text-primary/60" />
                <span className="font-medium">{service.service_name}:</span>
                <span>{service.service_time}</span>
              </div>
            ))}

            <div className="hidden sm:block w-px h-5 bg-primary/20" />

            <div className="flex items-center gap-2">
              <FiMapPin className="w-5 h-5 text-primary/60" />
              <span>
                <a href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(settings?.site_name + ',' + locationData.address + ',' + locationData.city + ',' + locationData.state + ' ' + locationData.zip_code)}`} target="_blank" rel="noopener noreferrer" className="hover:text-primary transition-colors">
                {locationData.address}, {locationData.city}, {locationData.state}
                </a>
              </span>
            </div>
          </div>

          {/* Bulletin Link */}
          {locationData.bulletin_link && (
            <Button
              to={locationData.bulletin_link}
              variant="secondary"
              size="sm"
              leftIcon={<FiFileText className="w-4 h-4" />}
            >
              {locationData.bulletin_button_text || 'View Bulletin'}
            </Button>
          )}
        </div>
      </motion.div>
    </section>
  );
}
